export const selectFullscreenElement = (state) => state.fullscreen.element;
